module.exports = __webpack_public_path__ + "img/benefit-01-farm.e1dfe277.png";